import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './LoginGateModal.module.css';
import { LockKeyhole } from 'lucide-react'; // Make sure you import an icon

const LoginGateModal = ({ onClose }) => {
    const navigate = useNavigate();

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <button onClick={onClose} className={styles.closeButton}>&times;</button>
                
                <div className={styles.iconContainer}>
                    <div style={{ background: '#f0f0f0', padding: '16px', borderRadius: '50%' }}>
                        <LockKeyhole size={32} color="#000" />
                    </div>
                </div>

                <h2 className={styles.title}>Unlock Full Access</h2>
                
                <p className={styles.description}>
                    You're just one step away! Log in to view verified phone numbers, see full addresses, and connect directly with top-rated local professionals.
                </p>
                
                <div className={styles.actions}>
                    <button 
                        onClick={() => navigate('/login')}
                        className={styles.loginBtn}
                    >
                        Log In to Build Start
                    </button>
                    
                    <button 
                        onClick={() => navigate('/select-role')}
                        className={styles.signupBtn}
                    >
                        Create a Free Account
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LoginGateModal;